__turbopack_context__.v({
  "container": "PEl-Ua_container",
});
